export interface Offer {
  slug: string;
  name: string;
  logo: string;
  officialUrl: string;
  rating10: number;
  bonusHeadline: string;
  payoutHeadline: string;
  minDepositGbp: number;
  pros: string[];
  cons: string[];
  scores: {
    payoutSpeed: number;
    gameVariety: number;
    bonusValue: number;
    trustScore: number;
    mobileExperience: number;
  };
  bonusDetails?: {
    matchPercent: number;
    maxBonus: number;
    wagering: number;
  };
  payoutMethods?: {
    method: string;
    speed: string;
    minAmount: number;
  }[];
}

export const offers: Offer[] = [
  {
    slug: 'all-british-casino',
    name: 'All British Casino',
    logo: '/images/offers/allbritishcasino.webp',
    officialUrl: 'https://www.allbritishcasino.com/',
    rating10: 9.2,
    bonusHeadline: 'Double your first deposit up to £100',
    payoutHeadline: 'Withdrawals processed within 24 hours',
    minDepositGbp: 10,
    pros: [
      'UK Gambling Commission licensed',
      'Fast payout processing',
      'Extensive UK payment methods',
      'Strong customer support',
      'No withdrawal fees'
    ],
    cons: [
      'Limited cryptocurrency options',
      'Wagering requirements apply'
    ],
    scores: {
      payoutSpeed: 95,
      gameVariety: 88,
      bonusValue: 85,
      trustScore: 92,
      mobileExperience: 90
    },
    bonusDetails: {
      matchPercent: 100,
      maxBonus: 100,
      wagering: 35
    },
    payoutMethods: [
      { method: 'Bank Transfer', speed: '24-48 hours', minAmount: 20 },
      { method: 'Visa/Mastercard', speed: '1-3 days', minAmount: 10 },
      { method: 'PayPal', speed: '24 hours', minAmount: 10 },
      { method: 'Skrill', speed: '24 hours', minAmount: 10 }
    ]
  },
  {
    slug: 'funcasino',
    name: 'FunCasino',
    logo: '/images/offers/funcasino.webp',
    officialUrl: 'https://www.funcasino.com/',
    rating10: 8.8,
    bonusHeadline: 'Welcome package worth £200',
    payoutHeadline: 'Instant e-wallet withdrawals',
    minDepositGbp: 20,
    pros: [
      'Modern game selection',
      'Instant e-wallet payouts',
      'Mobile-optimized platform',
      'Regular promotions',
      'Live dealer games available'
    ],
    cons: [
      'Higher minimum deposit',
      'Some payment methods have fees'
    ],
    scores: {
      payoutSpeed: 90,
      gameVariety: 85,
      bonusValue: 88,
      trustScore: 87,
      mobileExperience: 92
    },
    bonusDetails: {
      matchPercent: 100,
      maxBonus: 200,
      wagering: 40
    },
    payoutMethods: [
      { method: 'PayPal', speed: 'Instant', minAmount: 20 },
      { method: 'Skrill', speed: 'Instant', minAmount: 20 },
      { method: 'Neteller', speed: 'Instant', minAmount: 20 },
      { method: 'Bank Transfer', speed: '2-5 days', minAmount: 50 }
    ]
  },
  {
    slug: 'playojo',
    name: 'PlayOJO',
    logo: '/images/offers/playojo.webp',
    officialUrl: 'https://www.playojo.com/',
    rating10: 9.5,
    bonusHeadline: 'No wagering requirements ever',
    payoutHeadline: 'OJOplus cashback on every spin',
    minDepositGbp: 10,
    pros: [
      'Zero wagering requirements',
      'OJOplus cashback system',
      'Transparent terms',
      'Fast verification process',
      'Excellent mobile app'
    ],
    cons: [
      'No traditional welcome bonus',
      'Smaller initial bonus amount'
    ],
    scores: {
      payoutSpeed: 92,
      gameVariety: 90,
      bonusValue: 80,
      trustScore: 95,
      mobileExperience: 95
    },
    bonusDetails: {
      matchPercent: 0,
      maxBonus: 50,
      wagering: 0
    },
    payoutMethods: [
      { method: 'PayPal', speed: '24 hours', minAmount: 10 },
      { method: 'Bank Transfer', speed: '1-3 days', minAmount: 10 },
      { method: 'Visa/Mastercard', speed: '2-5 days', minAmount: 10 },
      { method: 'Apple Pay', speed: '24 hours', minAmount: 10 }
    ]
  }
];

export const getOfferBySlug = (slug: string): Offer | undefined => {
  return offers.find(offer => offer.slug === slug);
};

